module.exports = __webpack_public_path__ + "static/media/brbbanners.91f9efa8.png";